import React from 'react';
import IconRepeat from '@mui/icons-material/AutorenewRounded';
import IconEdit from '@mui/icons-material/EditOutlined';
import IconDelete from '@mui/icons-material/DeleteOutlineRounded';
import IconEvent from '@mui/icons-material/EventOutlined';
import { formatCurrency, formatDate, formatFrequency, hasValidEndDate } from '../utils/financeFormat';
import RowAction from './RowAction';
import EmptyState from './EmptyState';
import styles from './RecurringPanel.module.css';

/** Coluna lateral com as recorrências ativas (editar e excluir a original). */
function RecurringPanel({ items, onEdit, onDelete }) {
    return (
        <aside className={styles.card}>
            <div className={styles.head}>
                <span className={styles.headIcon}><IconRepeat fontSize="small" /></span>
                <div className={styles.headTexts}>
                    <h3 className={styles.title}>Recorrências ativas</h3>
                    <span className={styles.subtitle}>Lançamentos que se repetem sozinhos</span>
                </div>
                {items.length > 0 && <span className={styles.count}>{items.length}</span>}
            </div>

            {items.length > 0 ? (
                <ul className={styles.list}>
                    {items.map(transaction => {
                        const isIncome = transaction.type === 'income';
                        return (
                            <li key={transaction.id} className={styles.item}>
                                <span className={`${styles.dot} ${isIncome ? styles.dotIncome : styles.dotExpense}`} aria-hidden="true" />
                                <div className={styles.body}>
                                    <div className={styles.row}>
                                        <span className={styles.name}>{transaction.description}</span>
                                        <span className={`${styles.amount} ${isIncome ? styles.income : styles.expense}`}>
                                            {isIncome ? '+' : '-'} {formatCurrency(transaction.amount)}
                                        </span>
                                    </div>
                                    <div className={styles.meta}>
                                        <span className={styles.chip}>{formatFrequency(transaction.recurrenceFrequency)}</span>
                                        <span className={styles.dates}>
                                            <IconEvent className={styles.metaIcon} />
                                            {formatDate(transaction.recurrenceStartDate)}
                                            {hasValidEndDate(transaction.recurrenceEndDate) && (
                                                <> até {formatDate(transaction.recurrenceEndDate)}</>
                                            )}
                                        </span>
                                    </div>
                                </div>
                                <div className={styles.actions}>
                                    <RowAction title="Editar recorrência" onClick={() => onEdit(transaction)}>
                                        <IconEdit style={{ fontSize: 17 }} />
                                    </RowAction>
                                    <RowAction title="Excluir recorrência" tone="danger" onClick={() => onDelete(transaction)}>
                                        <IconDelete style={{ fontSize: 17 }} />
                                    </RowAction>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            ) : (
                <EmptyState
                    compact
                    icon={<IconRepeat />}
                    title="Nenhuma recorrência ativa"
                    text="Aluguel, mensalidades e outras contas fixas aparecem aqui ao marcar a transação como recorrente."
                />
            )}
        </aside>
    );
}

export default RecurringPanel;
